module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"limit-time":"Time limit on stage","lead-time":"Time on stage","no-product":"No product","responsible":"Owner","deal-value":"Card value","products-sum":"Products sum"},"pt-BR":{"limit-time":"Tempo limite do estágio","lead-time":"Tempo no estágio","no-product":"Sem produto","responsible":"Responsável","deal-value":"Valor do card","products-sum":"Soma dos produtos"}}')
  delete Component.options._Ctor
}
